<template>
  <div>
    <v-container fluid>
      <user-login v-if="!this.$store.getters.isLoggedOn && !this.$store.getters.showRegisterProcess "></user-login>
      <customer-table v-if="this.$store.getters.showCustomer && this.$store.getters.isLoggedOn"></customer-table>
      <lieferant-table v-if="this.$store.getters.showLieferant && this.$store.getters.isLoggedOn"></lieferant-table>
      <product-table v-if="this.$store.getters.showProduct && this.$store.getters.isLoggedOn"></product-table>
      <service-table v-if="this.$store.getters.showService && this.$store.getters.isLoggedOn"></service-table>
      <tax-table v-if="this.$store.getters.showTax && this.$store.getters.isLoggedOn"></tax-table>
      <wgruppe-table v-if="this.$store.getters.showWgruppe && this.$store.getters.isLoggedOn"></wgruppe-table>
      <rabatt-table v-if="this.$store.getters.showRabatt && this.$store.getters.isLoggedOn"></rabatt-table>
      <kondition-table v-if="this.$store.getters.showKondition && this.$store.getters.isLoggedOn"></kondition-table>
      <fzeile-table v-if="this.$store.getters.showFzeile && this.$store.getters.isLoggedOn"></fzeile-table>
      <mahntext-table v-if="this.$store.getters.showMahntext && this.$store.getters.isLoggedOn"></mahntext-table>
      <bankkonto-table v-if="this.$store.getters.showBankkonto && this.$store.getters.isLoggedOn"></bankkonto-table>
      <weingang-table v-if="this.$store.getters.showWeingang && this.$store.getters.isLoggedOn"></weingang-table>

      <faktura-table v-if="this.$store.getters.showRapport && this.$store.getters.isLoggedOn"></faktura-table>
      <faktura-table v-if="this.$store.getters.showOfferte && this.$store.getters.isLoggedOn"></faktura-table>
      <faktura-table v-if="this.$store.getters.showAuftrag && this.$store.getters.isLoggedOn"></faktura-table>
      <faktura-table v-if="this.$store.getters.showFaktura && this.$store.getters.isLoggedOn"></faktura-table>
      <faktura-table v-if="this.$store.getters.showFakturaVerbucht && this.$store.getters.isLoggedOn"></faktura-table>
      <faktura-table v-if="this.$store.getters.showFakturaArchiv && this.$store.getters.isLoggedOn"></faktura-table>

      <user-table v-if="this.$store.getters.showUser && this.$store.getters.isLoggedOn"></user-table>

      <optima-report v-if="this.$store.getters.showReport && this.$store.getters.isLoggedOn"></optima-report>
      <optima-help-list v-if="this.$store.getters.showHelpList"></optima-help-list>
      <optima-register v-if="this.$store.getters.showRegisterProcess"></optima-register>
      <optima-confirm-dialog v-if="this.$store.getters.showConfirmDialog"></optima-confirm-dialog>
      <optima-error-dialog v-if="this.$store.getters.showErrorDialog"></optima-error-dialog>
    </v-container>
  </div>
</template>

<script>
import UserLogin from "@/components/UserLogin";
import AuthorityHelper from "@/plugins/AuthorityHelper";
import OptimaReport from "@/components/OptimaReport";
import OptimaHelpList from "@/components/OptimaHelpList";
import OptimaRegister from "@/components/OptimaRegister";
import OptimaConfirmDialog from "@/components/OptimaConfirmDialog";
import OptimaErrorDialog from "@/components/OptimaErrorDialog";
import CustomerTable from "@/components/CustomerTable";
import LieferantTable from "@/components/LieferantTable";
import ProductTable from "@/components/ProductTable";
import ServiceTable from "@/components/ServiceTable";
import TaxTable from "@/components/TaxTable";
import WgruppeTable from "@/components/WgruppeTable";
import RabattTable from "@/components/RabattTable";
import KonditionTable from "@/components/KonditionTable";
import FzeileTable from "@/components/FzeileTable";
import MahntextTable from "@/components/MahntextTable";
import BankkontoTable from "@/components/BankkontoTable";
import WeingangTable from "@/components/WeingangTable";
import FakturaTable from "@/components/FakturaTable";
import UserTable from "@/components/UserTable";

export default {
  name: "optima-content",

  components: {
    UserLogin, OptimaReport, OptimaHelpList, OptimaConfirmDialog, OptimaErrorDialog, CustomerTable, ProductTable, ServiceTable,
    TaxTable, WgruppeTable, RabattTable, KonditionTable, FzeileTable, MahntextTable, LieferantTable, WeingangTable, FakturaTable, 
    UserTable, BankkontoTable, OptimaRegister
  },

  data: () => ({
    authorityHelper: null,
  }),

  created() {
    this.authorityHelper=new AuthorityHelper(this);
  },

  methods: {
  }

};
</script>

<style scoped>
</style>
